module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAkBAMAAAAEDBViAAAAAXNSR0IB2cksfwAAABtQTFRFAAAA////////////////////////////////600+wgAAAAl0Uk5TAFDvQGD/3+Dw/tO2tAAAAE9JREFUeJxjYIACIWUGbIAlNAyruGtoOHbloYHYlYc6YFceMqocC0hmUMUqHsbQilU8HIc5xTjtxeXOEasBa7oFasCe/lmwp38GBolmFC4AStM+9ii/8V8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/login-back-icon@2x.png
// module id = 863
// module chunks = 0